import { FC } from 'react';
import { Toolbar } from 'primereact/toolbar';
import SettingUpNavBlock from '../components/NavBlocks/SettingUpNavBlock';
import PlanningNavBlock from '../components/NavBlocks/PlanningNavBlock';
import MonitoringNavBlock from '../components/NavBlocks/MonitoringNavBlock';

const DashboardNetworkAdminOrNoStudentsRostered: FC = () => {
  return (
    <div className="grid nc_content-frame w-full">
      <Toolbar
        role="section"
        className="nc_page-header col-10 col-offset-1"
        center={
          <h1>
            Welcome to <em>Teach to One Roadmaps</em>!
          </h1>
        }
      ></Toolbar>
      <div className="flex flex-column gap-lg col-10 col-offset-1">
        <div className="w-full nc_block flex flex-column align-items-center">
          <Toolbar role="section" className="nc_block-header w-full" center={<h2>Set Up</h2>} />
          <SettingUpNavBlock />
        </div>
        <div className="w-full nc_block flex flex-column align-items-center">
          <Toolbar role="section" className="nc_block-header w-full" center={<h2>Plan</h2>} />
          <PlanningNavBlock />
        </div>
        <div className="w-full nc_block flex flex-column align-items-center">
          <Toolbar role="section" className="nc_block-header w-full" center={<h2>Monitor</h2>} />
          <MonitoringNavBlock />
        </div>
      </div>
    </div>
  );
};

export default DashboardNetworkAdminOrNoStudentsRostered;
